import React, { useCallback, useRef } from 'react'
import { useField, FieldHookConfig, FieldHelperProps } from 'formik'

import ErrorMessage from '@/components/formik/messages/ErrorMessage'
import SelectInput, { SelectInputProps, SelectOption } from '@/components/ui/inputs/SelectInput'

type SelectFieldProps = FieldHookConfig<SelectOption['value']> & SelectInputProps

const MemoizedSelectInput = React.memo(SelectInput)

export default function SelectField(props: SelectFieldProps) {
  const { disabled, readOnly } = props
  const [field, meta, helpers] = useField<SelectOption['value']>(props)

  const helpersRef = useRef<FieldHelperProps<SelectOption['value']>>(helpers)

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    helpersRef.current.setValue(newValue)
  }, [])

  return (
    <MemoizedSelectInput
      {...props}
      defaultValue={meta.initialValue}
      error={!!meta.error && meta.touched && !readOnly && !disabled}
      helperText={!!meta.error && meta.touched && !readOnly && !disabled && (
        <ErrorMessage error={meta.error} />
      )}
      name={field.name}
      onBlur={field.onBlur}
      onChange={handleChange}
      value={meta.value}
    />
  )
}